import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

@Directive({
  selector: '[phoneValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneValidatorDirective,
      multi: true
    }
  ]
})
export class PhoneValidatorDirective implements Validator, OnChanges {
  private phoneUtil: PhoneNumberUtil;

  @Input('phoneValidator') countryCode: string = 'US';

  constructor() {
    this.phoneUtil = PhoneNumberUtil.getInstance();
  }

  private onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryCode'] && this.onChange) {
      this.onChange();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    try {
      const phoneNumber = this.phoneUtil.parse(control.value, this.countryCode || 'US');
      const isValid = this.phoneUtil.isValidNumber(phoneNumber);
      return isValid ? null : { invalidPhone: true };
    } catch {
      return { invalidPhone: true };
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}
